import React, { useState } from "react";
import { motion } from "framer-motion";
import Footer from "../Base/Footer";
import Navbar from "./components/Navbar";

import img1 from "../assets/img/event-images/1.jpeg";
import img2 from "../assets/img/event-images/2.jpeg";
import img3 from "../assets/img/event-images/3.jpeg";
import img4 from "../assets/img/event-images/4.jpeg";
import img5 from "../assets/img/event-images/5.jpeg";
import img6 from "../assets/img/event-images/6.jpeg";

const user = {
  name: "Lauren Olivier",
  accountType: "EXECUTIVE",
  avatarUrl: "https://i.ibb.co/xqnrW3cK/woman-pfp.jpg",
  hasNotifications: true,
};

const portalPageStaggerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.08,
      delayChildren: 0.03,
    },
  },
};

const portalFadeUpVariants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.34, ease: [0.22, 1, 0.36, 1] },
  },
};

const ungaImages = [
  {
    src: img1,
    alt: "UNGA 2025 community moment",
  },
  {
    src: img2,
    alt: "UNGA 2025 collaboration and engagement",
  },
  {
    src: img3,
    alt: "UNGA 2025 curated board opportunity moment",
  },
  {
    src: img4,
    alt: "UNGA 2025 discussion with partners",
  },
  {
    src: img5,
    alt: "UNGA 2025 participants in conversation",
  },
  {
    src: img6,
    alt: "UNGA 2025 event highlights",
  },
];

function EventCarousel({ images }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const total = images.length;

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + total) % total);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % total);
  };

  const activeImage = images[activeIndex];

  return (
    <div className="events-page__carousel-frame">
      <div className="events-page__carousel-hero-wrap">
        <div className="events-page__carousel-hero">
          <img
            className="events-page__carousel-image"
            src={activeImage.src}
            alt={activeImage.alt}
          />
        </div>

        <button
          type="button"
          className="events-page__carousel-control events-page__carousel-control--prev"
          onClick={handlePrev}
          aria-label="Previous image"
        >
          ‹
        </button>
        <button
          type="button"
          className="events-page__carousel-control events-page__carousel-control--next"
          onClick={handleNext}
          aria-label="Next image"
        >
          ›
        </button>
      </div>

      <div className="events-page__thumb-grid">
        {images.map((image, index) => (
          <button
            key={image.src}
            type="button"
            className={`events-page__thumb ${
              activeIndex === index ? "is-active" : ""
            }`}
            onClick={() => setActiveIndex(index)}
            aria-label={`View image ${index + 1}`}
          >
            <img src={image.src} alt="" aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
}

export default function EventsPage() {
  return (
    <div className="ed-wrapper">
      <motion.div
        className="ed-main"
        initial="hidden"
        animate="show"
        variants={portalPageStaggerVariants}
      >
        <Navbar user={user} currentPage="events" />

        <motion.section className="hero-board bg-2" variants={portalFadeUpVariants}>
          <div className="hero-board__overlay" />
          <div className="hero-board__content">
            <h1 className="hero-board__title">Events</h1>
            <p className="hero-board__subtitle">
              Highlights from recent convenings and a look ahead at upcoming
              gatherings.
            </p>
          </div>
        </motion.section>

        <motion.section className="events-page" variants={portalFadeUpVariants}>
          <div className="events-page__inner">
            <div className="events-page__section-header">
              <h2 className="events-page__section-title">Past Events</h2>
            </div>

            <article className="events-page__event-card">
              <div className="events-page__event-content">
                <div className="events-page__event-meta">
                  <h3 className="events-page__event-title">UNGA 2025</h3>
                  <p className="events-page__event-detail">
                    <strong>Date:</strong> Sept 22-24, 2025
                  </p>
                  <p className="events-page__event-detail">
                    <strong>Location:</strong> New York City
                  </p>
                  <p className="events-page__event-detail events-page__event-detail--summary">
                    Photo highlights from Apollo&apos;s UNGA 2025 programming
                    and related convenings.
                  </p>
                </div>
                <div className="events-page__event-gallery">
                  <EventCarousel images={ungaImages} />
                </div>
              </div>
            </article>

            <div className="events-page__section-header events-page__section-header--upcoming">
              <h2 className="events-page__section-title">Upcoming</h2>
            </div>

            <div className="events-page__upcoming-grid">
              <article className="events-page__upcoming-card">
                <span className="events-page__badge">Upcoming</span>
                <h3 className="events-page__upcoming-title">SIS 2026</h3>
                <p className="events-page__upcoming-meta">
                  <strong>Date:</strong> June 2-3, 2026
                </p>
                <p className="events-page__upcoming-meta">
                  <strong>Location:</strong> Atlanta
                </p>
                <p className="events-page__upcoming-text">
                  Event details and photo album will be added after the event.
                </p>
              </article>

              <article className="events-page__upcoming-card">
                <span className="events-page__badge">Upcoming</span>
                <h3 className="events-page__upcoming-title">UNGA 2026</h3>
                <p className="events-page__upcoming-meta">
                  <strong>Date:</strong> September 8-22, 2026
                </p>
                <p className="events-page__upcoming-meta">
                  <strong>Location:</strong> New York City
                </p>
                <p className="events-page__upcoming-text">
                  Event details and photo album will be added after the event.
                </p>
              </article>
            </div>
          </div>
        </motion.section>

        <div className="ed-footer">
          <Footer alternate={true} />
        </div>
      </motion.div>
    </div>
  );
}
